import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

export default function Navbar() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [open, setOpen] = useState(false);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden"; // disable scroll
    } else {
      document.body.style.overflow = "auto"; // enable scroll
    }
  }, [open]);

  const handleClose = () => {
    setClosing(true);
    setTimeout(() => {
      setOpen(false);
      setClosing(false);
    }, 300); // match fadeOut animation time
  };

  if (isMobile) {
    return (
      <>
        <div className="navbar-mobile">
          {!open && (
            <button className="menu-btn" onClick={() => setOpen(true)}>☰</button>
          )}
        </div>

        {open && (
          <div className={`menu-overlay ${closing ? "closing" : ""}`}>
            <button className="close-btn" onClick={handleClose}>✖</button>
            <div className="menu-items">
              <NavLink to="/" onClick={handleClose} className={({ isActive }) => isActive ? "active" : ""}>Home</NavLink>
              <NavLink to="/about" onClick={handleClose} className={({ isActive }) => isActive ? "active" : ""}>About Us</NavLink>
              <NavLink to="/films" onClick={handleClose} className={({ isActive }) => isActive ? "active" : ""}>Upcoming Films</NavLink>
              <NavLink to="/contact" onClick={handleClose} className={({ isActive }) => isActive ? "active" : ""}>Contact Us</NavLink>
              <NavLink to="/pitch" onClick={handleClose} className={({ isActive }) => isActive ? "active" : ""}>Pitch Your Stories</NavLink>
            </div>
          </div>
        )}
      </>
    );
  }

  return (
    <div className="navbar-desktop">
      <NavLink to="/" className={({ isActive }) => isActive ? "active" : ""}>Home</NavLink>
      <NavLink to="/about" className={({ isActive }) => isActive ? "active" : ""}>About Us</NavLink>
      <NavLink to="/films" className={({ isActive }) => isActive ? "active" : ""}>Upcoming Films</NavLink>
      <NavLink to="/contact" className={({ isActive }) => isActive ? "active" : ""}>Contact Us</NavLink>
      <NavLink to="/pitch" className={({ isActive }) => isActive ? "active" : ""}>Pitch Your Stories</NavLink>
    </div>
  );
}